import * as swcHelpers from '@swc/helpers';
import { LineItemType, BundleLineItemType, BundleLineItemProductType, BillingFrequency, DeliveryFrequency } from '../../../__generated__/sharedTypes.js';

const MAIN_LINE_ITEM_INDEX = 0;
const mapContactLensesSubscriptionLineItem = ({ bundleLineItems , quantity , typeDetails  })=>{
    if (!bundleLineItems.every((item)=>Boolean(item.ratePlanId)
    )) {
        console.error(`All of the bundleLineItems must have a ratePlanId defined.`);
        return null;
    }
    var _quantity;
    return {
        sku: bundleLineItems[MAIN_LINE_ITEM_INDEX].sku,
        quantity: quantity !== null && quantity !== void 0 ? quantity : 1,
        lineItemType: LineItemType.BUNDLE,
        bundleLineItemsType: BundleLineItemType.CONTACT_LENSES_SUBSCRIPTION,
        bundleLineItems: bundleLineItems.map((item, index)=>swcHelpers.objectSpread({}, item, {
                type: BundleLineItemProductType[item.type.toUpperCase()],
                quantity: (_quantity = item.quantity) !== null && _quantity !== void 0 ? _quantity : 1,
                isMainBundleLineItem: index === MAIN_LINE_ITEM_INDEX
            })
        ),
        typeDetails: swcHelpers.objectSpread({}, typeDetails, {
            billingFrequency: BillingFrequency[typeDetails.billingFrequency.toUpperCase()],
            deliveryFrequency: DeliveryFrequency[typeDetails.deliveryFrequency.toUpperCase()]
        })
    };
};

export { mapContactLensesSubscriptionLineItem };
//# sourceMappingURL=contact-lenses-subscription.js.map
